import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubAreaComponent } from './sub-area.component';
import { MapMngr, mainMapMngr } from '../asp/MapMngr';
import * as settings from '../common/settings';

const MAIN_MAP_REDUCE_FACTOR = 0.6;
const MIN_SIZE = 250;

@Injectable({
  providedIn: 'root'
})
export class SubAreaService {

  private subAreas: Set<SubAreaComponent> = new Set();
  private subAreas3D: Set<SubAreaComponent> = new Set();

  constructor(private dialog: MatDialog) { 
  }

  public createSubArea(is3D: boolean, mapExtent? : settings.MapExtent) {
    if (!this.canCreateSubArea(is3D))
      return;
    
    let extent = mapExtent ? mapExtent : mainMapMngr.getMapExtent();

    let mainMapElem: Element = mainMapMngr.getMapElement();
    let height = mainMapElem.clientHeight * MAIN_MAP_REDUCE_FACTOR;
    let width;
    if (mapExtent) {
      width = height * mapExtent.width / mapExtent.height;
      if (width < MIN_SIZE)
        width = MIN_SIZE;
      if (width > mainMapElem.clientWidth * MAIN_MAP_REDUCE_FACTOR) {
        width = mainMapElem.clientWidth * MAIN_MAP_REDUCE_FACTOR;
        height = width * mapExtent.height / mapExtent.width;
        if (height < MIN_SIZE)
          height = MIN_SIZE;
      }
    }
    else {
      width = mainMapElem.clientWidth * MAIN_MAP_REDUCE_FACTOR;
    }
  
    // look for hidden sub area
    for (let subArea of (is3D ? this.subAreas3D : this.subAreas)) {
      if (!subArea.isShown()) {
        subArea.show(extent, width, height);
        return;
      }
    }

    let subArea = this.createHiddenSubArea(is3D);
    subArea.show(extent, width, height);
  }

  public canCreateSubArea(is3D: boolean): boolean {
    let shownCount = 0;
    for (let subArea of (is3D ? this.subAreas3D : this.subAreas)) {
      if (subArea.isShown())
        shownCount++;
    }
    return shownCount < (is3D ? SubAreaComponent.MAX_3D_AREA_NUM : SubAreaComponent.MAX_SUB_AREA_NUM);
  }

  // get all shown sub areas' map managers
  public getSubAreas(): Array<MapMngr> {
    let subAreas = new Array<MapMngr>();
    for (let subArea of this.subAreas) {
      if (subArea.isShown())
        subAreas.push(subArea.getMapMngr());
    }
    for (let subArea of this.subAreas3D) {
      if (subArea.isShown())
        subAreas.push(subArea.getMapMngr());
    }
    return subAreas;
  }

  private createHiddenSubArea(is3D: boolean): SubAreaComponent {
    let dialogRef = this.dialog.open(SubAreaComponent, SubAreaComponent.createDialogConfig(MIN_SIZE, is3D));
    let subArea = dialogRef.componentInstance;
    is3D ? this.subAreas3D.add(subArea) : this.subAreas.add(subArea);
    return subArea;
  }
}
